// extracted by mini-css-extract-plugin
export default {"slideContainer":"de561bac7d _8e4dd321f6 dbf0999549","slideImage":"d909e4243d"};